import { CONFIGURATION_APIS } from "@/api_framework/api_config";
import {
  IConfigurationEquipmentDetailResponse,
  IConfigurationEquipmentDetailResponseData,
} from "@/api_framework/api_modals/Configuration";
import { useConfiguration } from "@/app/hooks/useConfiguration";
import { useAppDispatch } from "@/app_redux/hooks/root_hook";
import axios, { AxiosError, AxiosResponse } from "axios";
import { useCallback, useState } from "react";
import toast from "react-hot-toast";
import { useCurlLogger } from "../../useCurlLogger";
import AxiosCurlirize from "axios-curlirize";

AxiosCurlirize(axios, () => {});
export const useConfigurationEquipmentDetailAPI = () => {
  const [equipmentDetails, setEquipmentDetails] = useState<IConfigurationEquipmentDetailResponseData | null>(null);
  const configuration = useConfiguration();
  const dispatch = useAppDispatch();
  const { sendCurl } = useCurlLogger();
  const execute = useCallback(
    async (equipmentId: string) => {
      try {
        const accessToken = localStorage.getItem(configuration.localStorage.ACCESS_TOKEN.key);

        if (!equipmentId) {
          return;
        }
        await axios
          .get(`${CONFIGURATION_APIS?.EQUIPMENT_DETAIL?.baseURL}`, {
            params: { equipment_id: equipmentId },
            headers: {
              Authorization: `${accessToken}`,
              "Content-Type": "application/json",
            },
          })
          .then((res: AxiosResponse<IConfigurationEquipmentDetailResponse>) => {
            if (res.data.status === true) {
              setEquipmentDetails(res.data.data);
            } else {
              toast.error("Error while updating equipment.");
            }
          })
          .catch((e: AxiosError) => {
            sendCurl(e.config["curlCommand"]);
          });
      } catch (error) {
        // Handle errors
        if (axios.isAxiosError(error)) {
          const axiosError = error as AxiosError;
          if (axiosError.code === "ERR_BAD_REQUEST") {
            toast.error("Error at server while fetching Equipment details.");
          }
          if (axiosError.response?.status === 400) {
            toast.error(axiosError.message);
          }
          if (axiosError.response?.status === 500) {
            toast.error("Internal Server Error, Contact Tech Team.");
          }
        } else {
          toast.error("Server Error: " + error.message);
        }
      }
    },
    [dispatch, configuration],
  );

  return { equipmentDetails, execute };
};
